import { Tab, Tabs } from '@mui/material';
import { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import Modal from '../../elements/Modal';
import {
  CreateCustomerForm,
  EditCustomerForm,
  InviteCustomerForm,
} from './CustomerForms';
import { addCustomer } from '../../../modules/admin';
import { useNotification } from '../../../hooks/NotificationContext';

export default function CustomerFormModal({
  fetchCustomerList,
  open,
  setOpen,
  customerToEdit = null,
}) {
  const { addNotification } = useNotification();

  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(0);

  const isEditMode = !!customerToEdit;
  const modalTitle = isEditMode ? 'Edit Customer' : 'Add New Customer';

  const handleModalClose = () => {
    setOpen(false);
    setTab(0);
    setLoading(false);
  };

  const handleInvite = async (customerData) => {
    setLoading(true);
    try {
      await addCustomer(customerData);
      setLoading(false);
      addNotification(
        'success',
        'An invite has been sent to the user! They will receive an email shortly.'
      );
      fetchCustomerList();
      handleModalClose();
    } catch (error) {
      setLoading(false);
      addNotification(
        'error',
        error.message || 'Unable to invite user. Please try again'
      );
    }
  };

  const handleCreateDirectly = async (customerData) => {
    setLoading(true);
    try {
      await addCustomer(customerData);
      setLoading(false);
      addNotification('success', 'Account has been created successfully.');
      fetchCustomerList();
      handleModalClose();
    } catch (error) {
      setLoading(false);
      addNotification(
        'error',
        error.message || 'Failed to create customer. Please try again.'
      );
    }
  };

  const handleEdit = async (updatedData) => {
    setLoading(true);
    try {
      console.log('Updating Customer:', updatedData);
      await new Promise((resolve) => setTimeout(resolve, 1500));
      setLoading(false);
      addNotification('success', 'Customer has been updated successfully.');
    } catch (error) {
      setLoading(false);
      addNotification(
        'error',
        error.message || 'Failed to update customer. Please try again.'
      );
    }
  };

  useEffect(() => {
    if (open && !isEditMode) {
      setTab(0);
    }
  }, [open, isEditMode]);

  const renderFormContent = () => {
    if (loading) {
      return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Spinner animation="border" />
          <p>Processing...</p>
        </div>
      );
    }

    if (isEditMode) {
      return (
        <EditCustomerForm
          customer={customerToEdit}
          handleEditSubmit={handleEdit}
          loading={loading}
        />
      );
    }

    return (
      <>
        <Tabs
          value={tab}
          onChange={(_, newValue) => setTab(newValue)}
          sx={{ mb: 3 }}>
          <Tab label="Invite Customer" />
          <Tab label="Create Account" />
        </Tabs>

        {tab === 0 ? (
          <InviteCustomerForm
            handleInviteSubmit={handleInvite}
            loading={loading}
          />
        ) : (
          <CreateCustomerForm
            handleCreateDirectlySubmit={handleCreateDirectly}
            loading={loading}
          />
        )}
      </>
    );
  };

  return (
    <Modal
      open={open}
      modalTitle={modalTitle}
      handleClose={handleModalClose}
      width={'sm'}>
      {renderFormContent()}
    </Modal>
  );
}
